var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-3567 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 120,
    height: 120,
    rx: 15,
    transform: "translate(3567 590)",
    fill: "#d9eaff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(3590.5 613.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M65.742,31.644A5.021,5.021,0,0,0,61,35.162H50.165V28.7a5.3,5.3,0,0,0-.79-2.8L54.9,20.374a4.977,4.977,0,1,0-2.082-2.082L47.293,23.82a5.5,5.5,0,0,0-2.8-.79H38.1V12.191a5.021,5.021,0,0,0,3.517-4.738,4.953,4.953,0,0,0-9.906,0,5.021,5.021,0,0,0,3.517,4.738V23.03H28.7a5.3,5.3,0,0,0-2.8.79l-5.527-5.527a4.977,4.977,0,1,0-2.082,2.082L23.82,25.9a5.5,5.5,0,0,0-.79,2.8V35.09H12.191a5.021,5.021,0,0,0-4.738-3.517,4.953,4.953,0,0,0,0,9.906,5.021,5.021,0,0,0,4.738-3.517H23.03v6.532a5.3,5.3,0,0,0,.79,2.8l-5.527,5.527A4.977,4.977,0,1,0,20.374,54.9L25.9,49.375a5.5,5.5,0,0,0,2.8.79H35.09V61a5.021,5.021,0,0,0-3.517,4.738,4.953,4.953,0,0,0,9.906,0A5.021,5.021,0,0,0,37.961,61V50.165h6.532a5.3,5.3,0,0,0,2.8-.79L52.821,54.9A4.977,4.977,0,1,0,54.9,52.821l-5.527-5.527a5.5,5.5,0,0,0,.79-2.8V38.1H61a5.021,5.021,0,0,0,4.738,3.517,4.963,4.963,0,0,0,4.953-4.953A5.025,5.025,0,0,0,65.742,31.644ZM44.135,42.412a1.747,1.747,0,0,1-1.723,1.723H30.783a1.747,1.747,0,0,1-1.723-1.723V30.783a1.747,1.747,0,0,1,1.723-1.723h11.7a1.747,1.747,0,0,1,1.723,1.723V42.412Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#0769e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(32.434 32.434)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 8.255,
    height: 8.255,
    fill: "#0769e3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentre);
export default __webpack_public_path__ + "static/media/Centre.d62370fc8903d50406c700cae38a3c53.svg";
export { ForwardRef as ReactComponent };